const switchModalEquipServQuest = {
  label: 'Incluir opção de comentário na pergunta?',
  label2: 'Ações geradas a partir dessa pergunta deixam o equipamento inapto para uso ?',
  label3: 'Incluir opção de arquivo na pergunta?',
  labelWeight: 'Peso da pergunta',
  labelWeightError: 'O valor deve ser maior que zero',
  labelDescriptiveImage: 'Imagem descritiva da pergunta',
};

export default switchModalEquipServQuest;
